import { createBrowserRouter } from "react-router-dom";

import RootLayout from "@/pages/layout";

import { authRoutes } from "./auth";
import { connectRoutes, callRoutes } from "./connect";
import { sidebarRoutes } from "./sidebar";
import ErrorBoundary from "@/components/ErrorBoundry";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorBoundary />,
    children: [sidebarRoutes, authRoutes, connectRoutes],
  },
  // New call routes (no layout wrapper)
  callRoutes,
]);
